/**
 * Join Block.
 * 
 * identical to Mission Block except this uses arrow nav, not dot nav.
 */

/**
 * Desktop: No slider.
 * Mobile: 1-slide slick slider.
 */

// Set up slick slider for benefits slides in mobile.
let 
	$window = $(window),
	sliderBreakpoint = 1024,
	$mySlider = $('.mission-block__benefits'),
    mySliderSettings = {
        adaptiveHeight:false,
		arrows:true,
		appendArrows: $('.mission-block__arrow-nav'),
		// centerMode:true,
		// dots: true,
		// appendDots: $('.mission-block__dot-nav'),
		fade: true,
		infinite: true,
        mobileFirst:true,
        slidesToShow:1,
        slidesToScroll:1,
        swipeToSlide:true,
		variableWidth:false,
        // responsive: [
		// 	{
		// 		breakpoint:1,
		// 		settings: {

		// 		}
		// 	},
		// 	{
		// 		breakpoint: 1023,
		// 		settings: 'unslick'
		// 	}
        // ]
    };

function initSlider() {
    console.log('JOIN: initSlider()');

	// $mySlider.slick(mySliderSettings);

	function handleSwitchSlick(mm) {
		console.log('JOIN: handleSwitchSlick()');
		if (mm.matches) {
			$mySlider.slick(mySliderSettings);
		} else if ($mySlider.hasClass('slick-initialized')) {
			$mySlider.slick('unslick');
		}
	}

	const mediaQuery = window.matchMedia('(max-width: 1023px)');

	handleSwitchSlick(mediaQuery);

	mediaQuery.addEventListener('change', function() {
		handleSwitchSlick(mediaQuery);
	});

	// const handleSwitchSlick = ((e) => {
	// 	if (e.matches) {
	// 		console.log('JOIN: initSlider(): SLICK');
	// 		$mySlider.slick(mySliderSettings);
	// 	} else if (element.hasClass('slick-initialized')) {
	// 		console.log('JOIN: initSlider(): UNSLICK');
	// 		$mySlider.slick('unslick');
	// 	}
	// });
	// console.log('JOIN: initSlider() 2');  
	// mediaQuery.addEventListener('change', handleSwitchSlick);
	// console.log('JOIN: initSlider() 3');
	// handleSwitchSlick(mediaQuery);
	// console.log('JOIN: initSlider() 4');
}

let
	prevWindowW = $window.width(),
	currWindowW = prevWindowW;

function initResizeWatcher() {
	// console.log('MISSION: initResizeWatcher()');
	$window.on('resize', function() {
		currWindowW = $window.width();
		// console.log('MISSION: WINDOW RESIZED: '+currWindowW+': '+prevWindowW);
		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= sliderBreakpoint) && (prevWindowW < sliderBreakpoint)) {
			// Unslick mobile photo slider.
			// if ($mySlider.hasClass('slick-initialized')) {
			// 	$mySlider.slick('unslick');
			// }
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < sliderBreakpoint) && (prevWindowW >= sliderBreakpoint)) {
			// Slick mobile slider.
			if (!$mySlider.hasClass('slick-initialized')) {
				$mySlider.slick(mySliderSettings);
			}
		}
		prevWindowW = $window.width();

		// // If slick arrows are hidden, reduce container bottom padding.
		// if (($window.width() < sliderBreakpoint) && ($('.positions-block__nav .slick-arrow').css('display') == 'none')) {
		// 	$('.positions-block__container').css('paddingBottom','84px');
		// } else {
		// 	$('.positions-block__container').css('paddingBottom','');
		// }
	});
}

exports.init = function () {
	// console.log('MISSION: exports.init');
    // Run init methods...

	initSlider();
	// initResizeWatcher();
};